import { render, staticRenderFns } from "./inappropriate.vue?vue&type=template&id=9c4654da&scoped=true"
import script from "./inappropriate.vue?vue&type=script&lang=js"
export * from "./inappropriate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4654da",
  null
  
)

export default component.exports